import React, { useEffect, useState } from "react";
import Pusher from "pusher-js";
import { useRouter } from "next/router";
import {
  getLatestBid,
  getAllBidsForBanker,
  getAllWrongBidsForBanker,
} from "services";
import { DateTime } from "luxon";
import BankerEventData from "./BankerEventData";
import { Loader } from "app";

// interface ExtendedNavigator extends Navigator {
//   connection?: {
//     downlink: number;
//   };
// }

export default function BankerAuctionFloor(props: any) {
  const [amount, setAmount] = useState(0);
  const [endTime, setEndTime] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [status, setStatus] = useState("");
  const [currentTime, setCurrentTime] = useState<any>(0);
  const [bidsEvent, setBidsEvent] = useState<any[]>([]);
  const [latestBid, setLatestBid] = useState<any>(null);
  const [prevBid, setPrevBid] = useState<any>(null);
  const [wrongBidsEvent, setWrongBidsEvent] = useState<any[]>([]);
  const [loading, setLoading] = useState<any>(true);
  // const [connectionStatus, setConnectionStatus] = useState<any>("Offline");
  const [isOnlineEventTriggered, setIsOnlineEventTriggered] =
    useState<any>(false);

  const {
    query: { id },
  } = useRouter();

  const router = useRouter();

  // pusher functionality
  useEffect(() => {
    Pusher.logToConsole = false;
    const pusher = new Pusher(`${process.env.NEXT_PUBLIC_PUSHER_KEY}`, {
      cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    });

    const channelId = `auction-event-${id}`;
    const channel = pusher.subscribe(channelId);

    channel.bind("bidding_value_has_been_changed", (data: any) => {
      handleDataChange(data);
      setBidsEvent((prev) => [...prev, data]);
    });

    channel.bind("user_placed_wrong_bid", (data: any) => {
      setWrongBidsEvent((prev) => [...prev, data]);
    });

    channel.bind("auction_event_has_started", (data: any) => {
      if (data) {
        setStatus("live");
      }
    });

    channel.bind("auction_event_has_ended", (data: any) => {
      if (data) {
        setStatus("end");
      }
    });

    pusher.connection.bind("error", function (err: any) {
      if (err?.error?.data?.code === 4004) {
        console.log(">>> detected limit error");
      } else if (err?.data?.code === 1006) {
        // Websocket: CLOSED ABNORMALLY
      }
    });

    pusher.connection.bind("disconnected", function (err: any) {
      console.log(">>> disconnected");
      // setConnectionStatus("Offline");
    });

    pusher.connection.bind("connected", function (err: any) {
      console.log("connected", pusher.sessionID);
      // setConnectionStatus("Online");
    });

    // pusher.connection.bind("state_change", (states: any) => {
    //   const { current, previous } = states;
    //   // console.log(`current state: ${current}, previous state: ${previous}`);
    //   switch (current) {
    //     case "failed":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "disconnected":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "unavailable":
    //       setConnectionStatus("Offline");
    //       break;
    //     case "connected":
    //       setConnectionStatus("Online");
    //       break;
    //     case "connecting":
    //       setConnectionStatus("Offline");
    //       break;
    //     default:
    //       break;
    //   }
    // });

    return function cleanup() {
      pusher.disconnect();
    };
  }, [id]);

  // if auction is ongoing and somebody came in between then fetch data from latest bid
  useEffect(() => {
    if (props.data) {
      (async () => {
        const allBid: any = await getAllBidsForBanker(props.data.uuid);

        const allWrongBids: any = await getAllWrongBidsForBanker(
          props.data.uuid
        );

        if (allBid) {
          setBidsEvent(allBid);
          if (allBid.length >= 2) {
            setPrevBid(allBid[allBid.length - 2]);
          }
        }
        if (allWrongBids) {
          setWrongBidsEvent(allWrongBids);
        }
        const lastBid: any = await getLatestBid(props.data.uuid);
        setLatestBid(lastBid);
        setStatus(props.data.status);
        const start_timestamp = DateTime.fromISO(props.data.start_date_time)
          .setZone("Asia/Kolkata")
          .toMillis();
        setStartTime(start_timestamp);

        if (lastBid) {
          setAmount(lastBid.final_amount);
          setEndTime(parseInt(lastBid.final_end_time));
        } else {
          setAmount(parseInt(props.data.reserve_price));
          setEndTime(parseInt(props.data.final_end_date));
        }
        setLoading(false);
      })();
    }
  }, [props.data]);

  // current time
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(
        DateTime.now().setZone("Asia/Kolkata").toFormat("hh:mm:ss a")
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   const handleOnline = () => {
  //     setConnectionStatus("Online");
  //     setIsOnlineEventTriggered(true);
  //   };
  //   const handleOffline = () => setConnectionStatus("Offline");

  //   window.addEventListener("online", handleOnline);
  //   window.addEventListener("offline", handleOffline);

  //   return () => {
  //     window.removeEventListener("online", handleOnline);
  //     window.removeEventListener("offline", handleOffline);
  //   };
  // }, []);

  // useEffect(() => {
  //   let intervalId: any;
  //   const navigatorWithConnection = navigator as ExtendedNavigator;

  //   const checkInternetSpeed = async () => {
  //     if (navigatorWithConnection.connection) {
  //       const downlinkSpeed = navigatorWithConnection.connection.downlink;

  //       const slowSpeedThreshold = Number(
  //         process.env.NEXT_PUBLIC_INTERNET_SPEED_LIMIT
  //       ); // Adjust as needed

  //       if (
  //         connectionStatus === "Online" &&
  //         downlinkSpeed < slowSpeedThreshold
  //       ) {
  //         setConnectionStatus("Connecting");
  //       }

  //       if (
  //         connectionStatus !== "Online" &&
  //         connectionStatus !== "Offline" &&
  //         downlinkSpeed > slowSpeedThreshold
  //       ) {
  //         setConnectionStatus("Online");
  //       }
  //     }
  //   };

  //   intervalId = setInterval(checkInternetSpeed, 1000); // Check every 1 second

  //   return () => clearInterval(intervalId); // Cleanup on unmount
  // }, [connectionStatus]);

  useEffect(() => {
    if (isOnlineEventTriggered) {
      router.reload();
    }
  }, [isOnlineEventTriggered]);

  const handleDataChange = async (data: any) => {
    setAmount(data.final_amount);
    setEndTime(data.final_end_time);
    if (latestBid) {
      setPrevBid(latestBid);
    }
    const lastBid: any = await getLatestBid(data.event_uuid);

    setLatestBid((prev: any) => {
      setPrevBid(prev);
      return lastBid;
    });
  };

  return (
    <div className="rounded-lg">
      <div className="mb-8">
        {loading ? (
          <div
            role="status"
            className="py-4 space-y-4 border border-gray-200 divide-y divide-gray-200 rounded shadow animate-pulse dark:divide-gray-700 md:p-6 dark:border-gray-700"
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <div className="flex items-center justify-between pt-4">
              <div>
                <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24 mb-2.5"></div>
                <div className="w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12"></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        ) : (
          <BankerEventData
            data={props.data}
            latestBidAmount={amount}
            startTime={startTime}
            endTime={endTime}
            status={status}
            currentTime={currentTime}
            latestBid={latestBid}
            prevBid={prevBid}
            correctBids={bidsEvent}
            wrongBids={wrongBidsEvent}
            // connectionStatus={connectionStatus}
          />
        )}
      </div>
    </div>
  );
}
